<template>
  
  <div v-if="show==false">
    <router-view />
  </div>
  <div v-else>
    <layout-vertical>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
  </div>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'

const noLayoutRoutes = [
  'personnalisation',
  'personnalisation-meyro',
  'scanReview',
  'scanFitting',
  'scanFittingGlass',
  'addPrescription',
  'orderDetailApp',
]

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
  },
  watch:{
      $route (to){
          this.show = !noLayoutRoutes.includes(to.name)
      }
  } ,
  data() {
    return {
      show: !noLayoutRoutes.includes(this.$route.name)
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
